import { render, staticRenderFns } from "./NewcomerMore.vue?vue&type=template&id=6e3e04ce&scoped=true"
import script from "./NewcomerMore.vue?vue&type=script&lang=js"
export * from "./NewcomerMore.vue?vue&type=script&lang=js"
import style0 from "./NewcomerMore.vue?vue&type=style&index=0&id=6e3e04ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3e04ce",
  null
  
)

export default component.exports